import { CellFormatter } from '@shared/execution/types';
import { HubspotCellFormatter } from './hubspot-cell-formatter';
import { ProviderType } from '@shared/types/flowstep';

export class CellFormatterFactory {
  getCellFormatter(provider: string): CellFormatter | null {
    if (provider === ProviderType.HS || provider === ProviderType.HubspotList) {
      return new HubspotCellFormatter();
    }
    return null;
  }
}
